// src/pages/despacho/Decretos.jsx
import { useState, useMemo, useEffect } from 'react';

// Base de datos de decretos
const decretosData = [
  // --- ABRIL 2026 ---
  { id: "144-022-GLP", fechaStr: "17 Abril 2026", fecha: "2026-04-17", asunto: "DESIGNACION GRAN GUARDA MAYOR TEMPLO JESUS GARCIA MALDONADO" },
  { id: "144-021-GLP", fechaStr: "17 Abril 2026", fecha: "2026-04-17", asunto: "DESIGNACION GRAN GUARDA MAYOR TEMPLO MANUEL CIPRIANO DULANTO VALENZUELA" },
  { id: "144-020-GLP", fechaStr: "17 Abril 2026", fecha: "2026-04-17", asunto: "AGRADECIMIENTO SACO DE BENEFICIENCIA LOGIA RAMON CASTILLA 112" },
  { id: "144-019-GLP", fechaStr: "16 Abril 2026", fecha: "2026-04-16", asunto: "AGRADECIMIENTO SACO DE BENEFICIENCIA LOGIA DELFOS 78" },
  { id: "144-018-GLP", fechaStr: "16 Abril 2026", fecha: "2026-04-16", asunto: "AGRADECIMIENTO SACO DE BENEFICIENCIA LOGIA DELTA 77" },
  { id: "144-017-GLP", fechaStr: "16 Abril 2026", fecha: "2026-04-16", asunto: "AGRADECIMIENTO SACO DE BENEFICIENCIA LOGIA UNION, PERSEVERANCIA Y FORTALEZA 171" },
  { id: "144-016-GLP", fechaStr: "16 Abril 2026", fecha: "2026-04-16", asunto: "DECLARANDO DUELO LA TEN.·. DE LAS RR.·.LL.·.SS.·. DE LA JURISDICCION POR EL Q.·.H.·. JORGE IGNACIO SANCHEZ PEREYRA (99)" },
  { id: "144-015-GLP", fechaStr: "15 Abril 2026", fecha: "2026-04-15", asunto: "REVISTA INTERNOS 2026-2028" },
  { id: "144-014-GLP", fechaStr: "15 Abril 2026", fecha: "2026-04-15", asunto: "AGRADECIMIENTO SACO DE BENEFICIENCIA LOGIA FRANCISCO JAVIER MARIATEGUI 76" },
  { id: "144-013-GLP", fechaStr: "10 Abril 2026", fecha: "2026-04-10", asunto: "DECLARANDO DUELO LA TEN.·. DE LAS RR.·.LL.·.SS.·. DE LA JURISDICCION POR EL Q.·.H.·. PERCY LUBER IPANAQUE NAVARRO (53)" },
  { id: "144-012-GLP", fechaStr: "10 Abril 2026", fecha: "2026-04-10", asunto: "DECLARANDO DUELO LA TEN.·. DE LAS RR.·.LL.·.SS.·. DE LA JURISDICCION POR EL R.·.H.·. CARLOS ENRIQUE FEIJOO CABRERA (22)" },
  { id: "144-011-GLP", fechaStr: "10 Abril 2026", fecha: "2026-04-10", asunto: "CONVOCATORIA ELECCIONES LOGIAS RITO ESCOCES ANTIGUO Y ACEPTADO 2026-2027" },
  { id: "144-010-GLP", fechaStr: "07 Abril 2026", fecha: "2026-04-07", asunto: "RECONOCIENDO MIEMBRO VITALICIO R.·.H.·. ALFREDO OSWALDO INJOQUE MEDRANO (46)" },
  { id: "144-009-GLP", fechaStr: "07 Abril 2026", fecha: "2026-04-07", asunto: "RECONOCIENDO MIEMBRO BENEMERITO R.·.H.·. NICOLAS FELIPE MEZA WALDE (152)" },
  { id: "144-008-GLP", fechaStr: "07 Abril 2026", fecha: "2026-04-07", asunto: "RECONOCIENDO MIEMBRO BENEMERITO R.·.H.·. AUGUSTO ALVAREZ ECHAIZ (103)" },
  { id: "144-007-GLP", fechaStr: "07 Abril 2026", fecha: "2026-04-07", asunto: "RECONOCIENDO MIEMBRO PREEMINENTE R.·.H.·. LUCIO ACOSTA MUÑOZ (33)" },
  { id: "144-006-GLP", fechaStr: "07 Abril 2026", fecha: "2026-04-07", asunto: "RECONOCIENDO MIEMBRO VITALICIO Q.·.H.·. JORGE LUIS SANCHEZ AYALA (14)" },

  // --- MARZO 2026 ---
  { id: "144-005-GLP", fechaStr: "27 Marzo 2026", fecha: "2026-03-27", asunto: "DECLARANDO DUELO LA TEN.·. DE LAS RR.·.LL.·.SS.·. DE LA JURISDICCION POR EL R.·.H.·. JUAN MANUEL ORAN MONTOYA (139)" },
  { id: "144-004-GLP", fechaStr: "26 Marzo 2026", fecha: "2026-03-26", asunto: "REGULARIZACION EXTRAORDINARIA 2026-2028" },
  { id: "144-003-GLP", fechaStr: "26 Marzo 2026", fecha: "2026-03-26", asunto: "AFILIACION EXTRAORDINARIA 2026-2028" },
  { id: "144-002-GLP", fechaStr: "26 Marzo 2026", fecha: "2026-03-26", asunto: "LEMA MASONICO G.·.L.·.P.·. 2026-2028" },
  { id: "144-001-GLP", fechaStr: "26 Marzo 2026", fecha: "2026-03-26", asunto: "GRAN CUADRO DE DD.·. Y OO.·. G.·.L.·.P.·. 2026-2028" },
  { id: "143-671-GLP", fechaStr: "23 Marzo 2026", fecha: "2026-03-23", asunto: "RITUAL INSTALACION REE" },
  { id: "143-670-GLP", fechaStr: "23 Marzo 2026", fecha: "2026-03-23", asunto: "RITUAL CRAFT Y MANUAL DE INSTRUCCIONES" },
  { id: "143-670-GLP (2)", fechaStr: "23 Marzo 2026", fecha: "2026-03-23", asunto: "MANUAL DE INSTRUCCIONES ROTW230" },
  { id: "143-669-GLP", fechaStr: "20 Marzo 2026", fecha: "2026-03-20", asunto: "AUTORIZACION RITUALES RITO EMULACION" },
  { id: "143-669-GLP (2)", fechaStr: "20 Marzo 2026", fecha: "2026-03-20", asunto: "RITUALES RITO EMULACION APRENDIZ ENTRADO" },
  { id: "143-669-GLP (3)", fechaStr: "20 Marzo 2026", fecha: "2026-03-20", asunto: "RITUALES RITO EMULACION COMPAÑERO DE OFICIO" },
  { id: "143-669-GLP (4)", fechaStr: "20 Marzo 2026", fecha: "2026-03-20", asunto: "RITUALES RITO EMULACION MAESTRO MASON" },
  { id: "143-668-GLP", fechaStr: "20 Marzo 2026", fecha: "2026-03-20", asunto: "APOYO ABOU SAAD SHRINERS CAPITULO PERU" },
  { id: "143-667-GLP", fechaStr: "19 Marzo 2026", fecha: "2026-03-19", asunto: "RECONOCIENDO MIEMBRO VITALICIO R.·.H.·. FRANCISCO FELIX CALDERON HURTADO (17)" },
  { id: "143-666-GLP", fechaStr: "19 Marzo 2026", fecha: "2026-03-19", asunto: "RECONOCIENDO MIEMBRO VITALICIO R.·.H.·. CARLOS EDUARDO TELLEZ MEJIA (17)" },
  { id: "143-665-GLP", fechaStr: "19 Marzo 2026", fecha: "2026-03-19", asunto: "FORMACION TRIANGULO MASONICO \"CABALLEROS DE HONOR, JUSTICIA Y LEALTAD\" T43 VALLE DE CHICLAYO" },
  { id: "143-664-GLP", fechaStr: "19 Marzo 2026", fecha: "2026-03-19", asunto: "RECONOCIENDO MIEMBRO BENEMERITO R.·.H.·. JAVIER HUMBERTO ORTEGA CARRASCO (107)" },
  { id: "143-663-GLP", fechaStr: "18 Marzo 2026", fecha: "2026-03-18", asunto: "ACUERDO DE LA SEPTIMA GRAN ASAMBLEA MODIFICACION ART. 25 DEL ESTATUTO" },
  { id: "143-662-GLP", fechaStr: "11 Marzo 2026", fecha: "2026-03-11", asunto: "HORA DE INICIO DE SEPTIMA GRAN ASAMBLEA EXTRAORDINARIA MIXTA O HIBRIDA 17 MARZO 2026" },
  { id: "143-661-GLP", fechaStr: "11 Marzo 2026", fecha: "2026-03-11", asunto: "EVENTO CULTURAL LOS BEATLES (142-162)" },
  { id: "143-660-GLP", fechaStr: "10 Marzo 2026", fecha: "2026-03-10", asunto: "RECONOCIMIENTO MIEMBRO EMINENTE AL R.·.H.·. EUGENIO ENRIQUE ARTAZA LLONA (109)" },
  { id: "143-659-GLP", fechaStr: "10 Marzo 2026", fecha: "2026-03-10", asunto: "RECONOCIMIENTO MIEMBRO EMINENTE AL R.·.H.·. ARTURO PAREJA CRUZ (9)" },
  { id: "143-658-GLP", fechaStr: "10 Marzo 2026", fecha: "2026-03-10", asunto: "REACTIVANDO COMO LOGIA MACHUPICCHU 208 VALLE DEL CUSCO" },
  { id: "143-657-GLP", fechaStr: "10 Marzo 2026", fecha: "2026-03-10", asunto: "RECONOCIENDO MIEMBRO VITALICIO Q.·.H.·. ADOLFO NUMA CUCHO MATTA (122)" },
  { id: "143-656-GLP", fechaStr: "10 Marzo 2026", fecha: "2026-03-10", asunto: "RECONOCIENDO MIEMBRO VITALICIO R.·.H.·. JORGE MOISES BRAVO TORO (36)" },
  { id: "143-655-GLP", fechaStr: "10 Marzo 2026", fecha: "2026-03-10", asunto: "RECONOCIMIENTO MIEMBRO PREEMINENTE AL R.·.H.·. MIGUEL ANGEL MONTOYA RAMIREZ (12)" },
  { id: "143-654-GLP", fechaStr: "10 Marzo 2026", fecha: "2026-03-10", asunto: "RECONOCIENDO MIEMBRO BENEMERITO R.·.H.·. AUGUSTO RAMIREZ AGURTO (27)" },
  { id: "143-653-GLP", fechaStr: "10 Marzo 2026", fecha: "2026-03-10", asunto: "RECONOCIENDO MIEMBRO VITALICIO R.·.H.·. GONZALO SILVA JUGO (27)" },
  { id: "143-652-GLP", fechaStr: "10 Marzo 2026", fecha: "2026-03-10", asunto: "AUTORIZACION DE IMPRESION DE RITUALES RITO YORK" },
  { id: "143-651-GLP", fechaStr: "10 Marzo 2026", fecha: "2026-03-10", asunto: "ADQUISICION DE DOS INMUEBLES EN EL VALLE DE PIURA" },
  { id: "143-650-GLP", fechaStr: "05 Marzo 2026", fecha: "2026-03-05", asunto: "ACUERDO DE LA SEXTA GRAN ASAMBLEA EXTRAORDINARIA DECLARAR NULO EL PROCESO Y LA IRRADIACION HH.: IQUITOS" },
  { id: "143-649-GLP", fechaStr: "05 Marzo 2026", fecha: "2026-03-05", asunto: "CONVOCATORIA SEPTIMA ASAMBLEA EXTRAORDINARIA ASOCIACION CIVIL GRAN LOGIA DEL PERU 25MAR2026" },
  { id: "143-648-GLP", fechaStr: "05 Marzo 2026", fecha: "2026-03-05", asunto: "CONVOCANDO A LA ASAMBLEA ANUAL POR EL 144 ANIVERSARIO DE LA GRAN LOGIA DEL PERU" },
  { id: "143-647-GLP", fechaStr: "05 Marzo 2026", fecha: "2026-03-05", asunto: "CONVOCANDO A LA SEPTIMA GRAN ASAMBLEA EXTRAORDINARIA MIXTA O HIBRIDA 17MAR2026" },
  { id: "143-646-GLP", fechaStr: "04 Marzo 2026", fecha: "2026-03-04", asunto: "ACUERDO SEXTA GRAN ASAMB.EXT. ABRIR INVESTIGACION SOBRE AUDITORIA" },
  { id: "143-645-GLP", fechaStr: "04 Marzo 2026", fecha: "2026-03-04", asunto: "ACUERDO SEXTA GRAN ASAMB.EXT. CONTINUAR IMPLEMENTACION SEGURIDAD GLP" },
  { id: "143-644-GLP", fechaStr: "04 Marzo 2026", fecha: "2026-03-04", asunto: "ACUERDO SEXTA GRAN ASAMB.EXT. NOMBRAMIENTO DE COMISION TSJ" },
  { id: "143-643-GLP", fechaStr: "04 Marzo 2026", fecha: "2026-03-04", asunto: "ACUERDO SEXTA GRAN ASAMB.EXT. AUTORIZAR CONTRATAR CON SUPREMO CONSEJO 33º" },
  { id: "143-642-GLP", fechaStr: "02 Marzo 2026", fecha: "2026-03-02", asunto: "DESIGNESE AL CARGO DE GRAN TESORERO ADJUNTO 2 DE LA GRAN LOGIA DEL PERU" },

  // --- FEBRERO 2026 ---
  { id: "143-640-GLP", fechaStr: "25 Febrero 2026", fecha: "2026-02-25", asunto: "DECLARANDO DUELO LA TEN.·. DE LAS RR.·.LL.·.SS.·. DE LA JURISDICCION POR EL Q.·.H.·. JAIME ALVARO ESPEJO MERA (118)" },
  { id: "143-639-GLP", fechaStr: "25 Febrero 2026", fecha: "2026-02-25", asunto: "DECLARANDO DUELO LA TEN.·. DE LAS RR.·.LL.·.SS.·. DE LA JURISDICCION POR EL R.·.H.·. ATILIO ANGEL LEVERATTO ESCALA (42)" },
  { id: "143-638-GLP", fechaStr: "25 Febrero 2026", fecha: "2026-02-25", asunto: "RECONOCIENDO MIEMBRO BENEMERITO R.·.H.·. CESAR AUGUSTO RIZO PATRON CARRASCO (231)" },
  { id: "143-637-GLP", fechaStr: "25 Febrero 2026", fecha: "2026-02-25", asunto: "RECONOCIENDO MIEMBRO VITALICIO R.·.H.·. HIPOLITO CARLOS ESPEJO BURGOS (79)" },
  { id: "143-636-GLP", fechaStr: "25 Febrero 2026", fecha: "2026-02-25", asunto: "RECONOCIENDO MIEMBRO VITALICIO R.·.H.·. EFRAIN BONIFACIO GONZALES SALCEDO (79)" },
  { id: "143-635-GLP", fechaStr: "25 Febrero 2026", fecha: "2026-02-25", asunto: "RECONOCIENDO MIEMBRO BENEMERITO R.·.H.·. MARCOS ALEJANDRO LOZANO OLIART (23)" },
  { id: "143-634-GLP", fechaStr: "25 Febrero 2026", fecha: "2026-02-25", asunto: "RECONOCIENDO MIEMBRO VITALICIO R.·.H.·. ALVARO ERNESTO RODRIGUEZ HERRERA (23)" },
  { id: "143-633-GLP", fechaStr: "25 Febrero 2026", fecha: "2026-02-25", asunto: "RECONOCIENDO MIEMBRO BENEMERITO R.·.H.·. JOSE RAUL UBALDO ALIAGA (173)" },
  { id: "143-632-GLP", fechaStr: "25 Febrero 2026", fecha: "2026-02-25", asunto: "ELECCION CUADRO CR VVMMII AMAUTAS GRAN REGION 10 CUSCO" },
  { id: "143-631-GLP", fechaStr: "25 Febrero 2026", fecha: "2026-02-25", asunto: "RECONOCIMIENTO MIEMBRO PREEMINENTE AL R.·.H.·. RICARDO MANUEL MIGNONE TORRES (94)" },
  { id: "143-630-GLP", fechaStr: "25 Febrero 2026", fecha: "2026-02-25", asunto: "CONTINUACION SEXTA GRAN ASAMBLEA EXTRAORDINARIA DE LA GLP 03MAR2026" },
  { id: "143-629-GLP", fechaStr: "23 Febrero 2026", fecha: "2026-02-23", asunto: "DISPONGASE LA CANCELACION DE TRIANGULOS MASONICOS" },
  { id: "143-628-GLP", fechaStr: "16 Febrero 2026", fecha: "2026-02-16", asunto: "FONDO EDITORIAL Y LIBROS DEL R.H. ABEL CONTRERAS GONZALEZ" },
  { id: "143-627-GLP", fechaStr: "13 Febrero 2026", fecha: "2026-02-13", asunto: "DECLARANDO DUELO LA TEN.·. DE LAS RR.·.LL.·.SS.·. DE LA JURISDICCION POR EL R.·.H.·. LUIS ALFREDO CUBA OVALLE (176)" },
  { id: "143-626-GLP", fechaStr: "13 Febrero 2026", fecha: "2026-02-13", asunto: "DECLARANDO DUELO LA TEN.·. DE LAS RR.·.LL.·.SS.·. DE LA JURISDICCION POR EL R.·.H.·. CARLOS JAIME GUADALUPE SUELDO (42)" },
  { id: "143-625-GLP", fechaStr: "13 Febrero 2026", fecha: "2026-02-13", asunto: "DECLARANDO DUELO LA TEN.·. DE LAS RR.·.LL.·.SS.·. DE LA JURISDICCION POR EL R.·.H.·. JUAN JOSE MORALES MURO (42)" },
  { id: "143-624-GLP", fechaStr: "13 Febrero 2026", fecha: "2026-02-13", asunto: "DECLARANDO DUELO LA TEN.·. DE LAS RR.·.LL.·.SS.·. DE LA JURISDICCION POR EL R.·.H.·. JESUS ENRIQUE LOPEZ ARELLANO (130)" },
  { id: "143-623-GLP", fechaStr: "13 Febrero 2026", fecha: "2026-02-13", asunto: "RECONOCIENDO MIEMBRO VITALICIO R.·.H.·. JORGE NAPOLEON MANTILLA LOPEZ (93)" },
  { id: "143-622-GLP", fechaStr: "13 Febrero 2026", fecha: "2026-02-13", asunto: "RECONOCIENDO MIEMBRO PREEMINENTE RH WALTER DEL AGUILA ROJAS (95)" }
];

const Decretos = () => {
  // Efecto para hacer scroll al inicio al cargar la vista
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [searchTerm, setSearchTerm] = useState('');
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  
  // Estado para la paginación
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  // Si los filtros cambian, volvemos a la página 1
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, fechaDesde, fechaHasta]);

  // Lógica de filtrado
  const decretosFiltrados = useMemo(() => {
    return decretosData.filter(decreto => {
      const coincideTexto = 
        decreto.asunto.toLowerCase().includes(searchTerm.toLowerCase()) ||
        decreto.id.toLowerCase().includes(searchTerm.toLowerCase());

      let coincideDesde = true;
      let coincideHasta = true;

      if (fechaDesde) {
        coincideDesde = new Date(decreto.fecha) >= new Date(fechaDesde);
      }
      if (fechaHasta) {
        coincideHasta = new Date(decreto.fecha) <= new Date(fechaHasta);
      }

      return coincideTexto && coincideDesde && coincideHasta;
    });
  }, [searchTerm, fechaDesde, fechaHasta]);

  // Lógica de Paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDecretos = decretosFiltrados.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(decretosFiltrados.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24 flex flex-col">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=2000&auto=format&fit=crop')" }} 
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Documentación Oficial
          </p>
          <h1 className="font-serif text-4xl md:text-6xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-6">
            Relación de Decretos
          </h1>
          <p className="text-gray-400 font-light text-sm md:text-base max-w-2xl mx-auto animate-fade-in [animation-delay:0.6s]">
            Resoluciones y disposiciones emitidas por el Gran Maestro de la Gran Logia del Perú.
          </p>
        </div>
      </section>

      {/* Contenido Principal */}
      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 py-16 md:py-24 flex-grow w-full">
        
        {/* PANEL DE FILTROS */}
        <div className="bg-gradient-to-br from-[#0a0a0a] to-[#111111] border border-white/5 p-6 md:p-8 mb-12 shadow-2xl flex flex-col lg:flex-row gap-6 items-end justify-between">
          
          <div className="w-full lg:w-2/5 relative">
            <label className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-2 font-semibold">
              Buscar Asunto o Decreto
            </label>
            <div className="relative">
              <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input 
                type="text" 
                placeholder="Ej. Reconociendo Miembro..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full bg-[#050505] border border-white/10 text-white pl-12 pr-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors placeholder-gray-600 font-light text-sm"
              />
            </div>
          </div>

          <div className="w-full lg:w-3/5 flex flex-col sm:flex-row gap-4">
            <div className="w-full">
              <label className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-2 font-semibold">
                Fecha "Desde"
              </label>
              <input 
                type="date" 
                value={fechaDesde}
                onChange={(e) => setFechaDesde(e.target.value)}
                className="w-full bg-[#050505] border border-white/10 text-gray-300 px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors text-sm"
                style={{ colorScheme: "dark" }}
              />
            </div>
            <div className="w-full">
              <label className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-2 font-semibold">
                Fecha "Hasta"
              </label>
              <input 
                type="date" 
                value={fechaHasta}
                onChange={(e) => setFechaHasta(e.target.value)}
                className="w-full bg-[#050505] border border-white/10 text-gray-300 px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors text-sm"
                style={{ colorScheme: "dark" }}
              />
            </div>
            
            <div className="w-full sm:w-auto flex items-end">
              <button 
                onClick={() => { setSearchTerm(''); setFechaDesde(''); setFechaHasta(''); }}
                className="w-full sm:w-auto px-6 py-3 border border-white/20 text-gray-400 text-xs tracking-widest uppercase hover:bg-white/5 hover:text-white transition-colors h-[46px] whitespace-nowrap"
              >
                Limpiar
              </button>
            </div>
          </div>
        </div>

        {/* CONTADOR DE RESULTADOS */}
        <div className="mb-6 flex justify-between items-center border-b border-white/10 pb-4">
          <h2 className="font-serif text-2xl text-white">Repositorio Documental</h2>
          <span className="text-gray-500 text-xs tracking-widest uppercase">
            Mostrando {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, decretosFiltrados.length)} de {decretosFiltrados.length} Registros
          </span>
        </div>

        {/* LISTA DE DECRETOS */}
        {currentDecretos.length > 0 ? (
          <div className="flex flex-col gap-3">
            {currentDecretos.map((decreto, idx) => (
              <div 
                key={idx} 
                className="group flex flex-col md:flex-row justify-between md:items-center bg-[#0a0a0a] hover:bg-[#111111] border border-white/5 hover:border-[#C5A059]/30 p-5 transition-all duration-300 gap-4"
              >
                <div className="w-full md:w-1/4 flex flex-col gap-1">
                  <span className="text-[#C5A059] font-mono text-xs tracking-widest uppercase">
                    {decreto.fechaStr}
                  </span>
                  <span className="text-white font-serif text-lg">
                    {decreto.id}
                  </span>
                </div>
                
                <div className="w-full md:w-3/4">
                  <p className="text-gray-300 font-light text-sm md:text-base leading-relaxed group-hover:text-white transition-colors">
                    {decreto.asunto}
                  </p>
                </div>

                <div className="w-full md:w-auto flex justify-end md:ml-4">
                  <button className="text-[#C5A059] opacity-0 group-hover:opacity-100 transition-opacity p-2 hover:bg-[#C5A059]/10 rounded-full" title="Descargar PDF">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20 bg-[#0a0a0a] border border-white/5">
            <svg className="w-12 h-12 text-gray-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p className="text-gray-400 text-lg font-light">No se encontraron decretos para la búsqueda o rango de fechas seleccionado.</p>
          </div>
        )}

        {/* CONTROLES DE PAGINACIÓN */}
        {totalPages > 1 && (
          <div className="mt-12 flex justify-center items-center gap-2">
            <button 
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className={`p-2 border ${currentPage === 1 ? 'border-white/5 text-gray-700 cursor-not-allowed' : 'border-white/20 text-gray-400 hover:text-[#C5A059] hover:border-[#C5A059] transition-colors'}`}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 19l-7-7 7-7" /></svg>
            </button>
            
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => paginate(i + 1)}
                className={`w-10 h-10 flex items-center justify-center font-mono text-sm transition-colors ${
                  currentPage === i + 1 
                    ? 'bg-[#C5A059] text-[#050505] font-bold' 
                    : 'border border-white/10 text-gray-400 hover:border-[#C5A059] hover:text-white'
                }`}
              >
                {i + 1}
              </button>
            ))}

            <button 
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`p-2 border ${currentPage === totalPages ? 'border-white/5 text-gray-700 cursor-not-allowed' : 'border-white/20 text-gray-400 hover:text-[#C5A059] hover:border-[#C5A059] transition-colors'}`}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 5l7 7-7 7" /></svg>
            </button>
          </div>
        )}

      </section>
    </div>
  );
};

export default Decretos;